/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type MyHomeQueryVariables = {
    id: string;
    today: string;
};
export type MyHomeQueryResponse = {
    readonly fraction: {
        readonly id: string;
        readonly __typename: string;
        readonly " $fragmentRefs": FragmentRefs<"PropertyBannerCardFragment" | "PropertyGuidelinesSectionFragment">;
    } | null;
};
export type MyHomeQuery = {
    readonly response: MyHomeQueryResponse;
    readonly variables: MyHomeQueryVariables;
};



/*
query MyHomeQuery(
  $id: ID!
  $today: date!
) {
  fraction: node(id: $id) {
    id
    __typename
    ... on property_fractions {
      ...PropertyBannerCardFragment
      ...PropertyGuidelinesSectionFragment
    }
  }
}

fragment PropertyBannerCardFragment on property_fractions {
  property {
    imageUrl: image_url
    id
  }
  ...PropertyHotDataCardFragment
}

fragment PropertyGuidelinesCardFragment on property_manual_categories {
  id
  manuals(order_by: {order: asc}) {
    id
    manual {
      id
      title
      description: description_rich
    }
  }
}

fragment PropertyGuidelinesSectionFragment on property_fractions {
  property {
    categories: property_manual_categories(order_by: {order: asc}) {
      id
      title
      ...PropertyGuidelinesCardFragment
    }
    id
  }
}

fragment PropertyHotDataAccessCodeItemFragment on property_fractions {
  property {
    accessCode: access_code
    id
  }
}

fragment PropertyHotDataAddressItemFragment on property_fractions {
  property {
    address {
      street1: street_1
      street2: street_2
      dependentLocality: dependent_locality
      locality
      state
      country
      postalCode: postal_code
      lngLat: lng_lat
      id
    }
    id
  }
}

fragment PropertyHotDataCardFragment on property_fractions {
  property {
    imageUrl: image_url
    id
  }
  ...PropertyUpcomingStayCardFragment
  ...PropertyHotDataAccessCodeItemFragment
  ...PropertyHotDataAddressItemFragment
  ...PropertyHotDataConciergeItemFragment
  ...PropertyHotDataWifiItemFragment
}

fragment PropertyHotDataConciergeItemFragment on property_fractions {
  property {
    conciergeName: concierge_name
    conciergeWhatsapp: concierge_whatsapp
    id
  }
  ...useConciergeHrefFragment
}

fragment PropertyHotDataWifiItemFragment on property_fractions {
  property {
    wifiName: wifi_name
    wifiPassword: wifi_password
    id
  }
}

fragment PropertyUpcomingStayCardFragment on property_fractions {
  property {
    name
    conciergeWhatsapp: concierge_whatsapp
    id
  }
  bookings(where: {date_start: {_gte: $today}, _or: [{booking_type: {_eq: STAY}}, {booking_type: {_eq: RENTAL}}]}, limit: 1, order_by: {date_start: asc}) {
    id
    dateStart: date_start
    dateEnd: date_end
    bookingType: booking_type
  }
  ...useConciergeHrefFragment
}

fragment useConciergeHrefFragment on property_fractions {
  property {
    conciergeWhatsapp: concierge_whatsapp
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "today"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = [
  {
    "kind": "Literal",
    "name": "order_by",
    "value": {
      "order": "asc"
    }
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MyHomeQuery",
    "selections": [
      {
        "alias": "fraction",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "PropertyBannerCardFragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "PropertyGuidelinesSectionFragment"
              }
            ],
            "type": "property_fractions",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "query_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MyHomeQuery",
    "selections": [
      {
        "alias": "fraction",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "properties",
                "kind": "LinkedField",
                "name": "property",
                "plural": false,
                "selections": [
                  {
                    "alias": "imageUrl",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "image_url",
                    "storageKey": null
                  },
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": "conciergeWhatsapp",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "concierge_whatsapp",
                    "storageKey": null
                  },
                  {
                    "alias": "accessCode",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "access_code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "addresses",
                    "kind": "LinkedField",
                    "name": "address",
                    "plural": false,
                    "selections": [
                      {
                        "alias": "street1",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "street_1",
                        "storageKey": null
                      },
                      {
                        "alias": "street2",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "street_2",
                        "storageKey": null
                      },
                      {
                        "alias": "dependentLocality",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "dependent_locality",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "locality",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "state",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "country",
                        "storageKey": null
                      },
                      {
                        "alias": "postalCode",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "postal_code",
                        "storageKey": null
                      },
                      {
                        "alias": "lngLat",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lng_lat",
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "conciergeName",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "concierge_name",
                    "storageKey": null
                  },
                  {
                    "alias": "wifiName",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "wifi_name",
                    "storageKey": null
                  },
                  {
                    "alias": "wifiPassword",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "wifi_password",
                    "storageKey": null
                  },
                  {
                    "alias": "categories",
                    "args": (v4/*: any*/),
                    "concreteType": "property_manual_categories",
                    "kind": "LinkedField",
                    "name": "property_manual_categories",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": (v4/*: any*/),
                        "concreteType": "property_manual_categories_manuals",
                        "kind": "LinkedField",
                        "name": "manuals",
                        "plural": true,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "manuals",
                            "kind": "LinkedField",
                            "name": "manual",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v5/*: any*/),
                              {
                                "alias": "description",
                                "args": null,
                                "kind": "ScalarField",
                                "name": "description_rich",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "manuals(order_by:{\"order\":\"asc\"})"
                      }
                    ],
                    "storageKey": "property_manual_categories(order_by:{\"order\":\"asc\"})"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "limit",
                    "value": 1
                  },
                  {
                    "kind": "Literal",
                    "name": "order_by",
                    "value": {
                      "date_start": "asc"
                    }
                  },
                  {
                    "fields": [
                      {
                        "kind": "Literal",
                        "name": "_or",
                        "value": [
                          {
                            "booking_type": {
                              "_eq": "STAY"
                            }
                          },
                          {
                            "booking_type": {
                              "_eq": "RENTAL"
                            }
                          }
                        ]
                      },
                      {
                        "fields": [
                          {
                            "kind": "Variable",
                            "name": "_gte",
                            "variableName": "today"
                          }
                        ],
                        "kind": "ObjectValue",
                        "name": "date_start"
                      }
                    ],
                    "kind": "ObjectValue",
                    "name": "where"
                  }
                ],
                "concreteType": "bookings",
                "kind": "LinkedField",
                "name": "bookings",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": "dateStart",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "date_start",
                    "storageKey": null
                  },
                  {
                    "alias": "dateEnd",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "date_end",
                    "storageKey": null
                  },
                  {
                    "alias": "bookingType",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "booking_type",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "property_fractions",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e21ece092fc8e65233903ab2998493e7",
    "id": null,
    "metadata": {},
    "name": "MyHomeQuery",
    "operationKind": "query",
    "text": "query MyHomeQuery(\n  $id: ID!\n  $today: date!\n) {\n  fraction: node(id: $id) {\n    id\n    __typename\n    ... on property_fractions {\n      ...PropertyBannerCardFragment\n      ...PropertyGuidelinesSectionFragment\n    }\n  }\n}\n\nfragment PropertyBannerCardFragment on property_fractions {\n  property {\n    imageUrl: image_url\n    id\n  }\n  ...PropertyHotDataCardFragment\n}\n\nfragment PropertyGuidelinesCardFragment on property_manual_categories {\n  id\n  manuals(order_by: {order: asc}) {\n    id\n    manual {\n      id\n      title\n      description: description_rich\n    }\n  }\n}\n\nfragment PropertyGuidelinesSectionFragment on property_fractions {\n  property {\n    categories: property_manual_categories(order_by: {order: asc}) {\n      id\n      title\n      ...PropertyGuidelinesCardFragment\n    }\n    id\n  }\n}\n\nfragment PropertyHotDataAccessCodeItemFragment on property_fractions {\n  property {\n    accessCode: access_code\n    id\n  }\n}\n\nfragment PropertyHotDataAddressItemFragment on property_fractions {\n  property {\n    address {\n      street1: street_1\n      street2: street_2\n      dependentLocality: dependent_locality\n      locality\n      state\n      country\n      postalCode: postal_code\n      lngLat: lng_lat\n      id\n    }\n    id\n  }\n}\n\nfragment PropertyHotDataCardFragment on property_fractions {\n  property {\n    imageUrl: image_url\n    id\n  }\n  ...PropertyUpcomingStayCardFragment\n  ...PropertyHotDataAccessCodeItemFragment\n  ...PropertyHotDataAddressItemFragment\n  ...PropertyHotDataConciergeItemFragment\n  ...PropertyHotDataWifiItemFragment\n}\n\nfragment PropertyHotDataConciergeItemFragment on property_fractions {\n  property {\n    conciergeName: concierge_name\n    conciergeWhatsapp: concierge_whatsapp\n    id\n  }\n  ...useConciergeHrefFragment\n}\n\nfragment PropertyHotDataWifiItemFragment on property_fractions {\n  property {\n    wifiName: wifi_name\n    wifiPassword: wifi_password\n    id\n  }\n}\n\nfragment PropertyUpcomingStayCardFragment on property_fractions {\n  property {\n    name\n    conciergeWhatsapp: concierge_whatsapp\n    id\n  }\n  bookings(where: {date_start: {_gte: $today}, _or: [{booking_type: {_eq: STAY}}, {booking_type: {_eq: RENTAL}}]}, limit: 1, order_by: {date_start: asc}) {\n    id\n    dateStart: date_start\n    dateEnd: date_end\n    bookingType: booking_type\n  }\n  ...useConciergeHrefFragment\n}\n\nfragment useConciergeHrefFragment on property_fractions {\n  property {\n    conciergeWhatsapp: concierge_whatsapp\n    id\n  }\n}\n"
  }
};
})();
(node as any).hash = 'fc75a999ff3b5dccebeca87fdfd6dc52';
export default node;
